import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Static.css";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { usePage } from "modules/core/api/pages/hooks/usePage";
import { LoaderFullscreen } from "modules/core/components";

export const Terms = () => {
  const { page } = usePage("terms");

  useEffect(() => {
    document.title = `Terms of Use | Staidium`;
  }, []);

  if (!page) return <LoaderFullscreen />;

  return (
    <>
      <Breadcrumb title="Terms of Use" />
      <div className="static-page">
        <Container>
          <Row>
            <Col lg={12}>
              <div
                style={{ color: "#fff" }}
                dangerouslySetInnerHTML={{ __html: page?.content ?? "" }}
              ></div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
